import { createApiAction } from '@saucelabs/sl-util-redux';
import { OrderedSet } from 'immutable';

import { getFilterParamsAdapter, getTimeFilterParams } from './../../api-adapter';
import * as actions from './actions';
import * as api from './api';
import * as constants from './types';
import * as urlQueryString from './../../urlQueryString';
import * as util from './../../util';


// get filters
export const getFilters = createApiAction(
  constants.GET_FILTERS,
  (payload, meta, dispatch, getState) => {
    const { apps: { analytics } } = getState();
    const params = {
      ...getFilterParamsAdapter(analytics.filters.get('filters')),
      ...getTimeFilterParams(analytics.filters.get('selectedDateFilter')),
    };

    return api.getFilters(params);
  },
);

export const clearAndGetFilters = (payload, meta) => (dispatch) => {
  dispatch(actions.clearSelectedFilters(payload, meta));
  return dispatch(getFilters());
};

export const selectAndGetFilterItems = (payload, meta) => (dispatch) => {
  dispatch(actions.selectFilterItems(payload, meta));
  return dispatch(getFilters());
};

export const setInitialFilters = (user, location, defaultFilters) => (dispatch) => {
  const allQueryParams = urlQueryString.getAll(location);
  const filters = util.getFiltersFromQueryParams(allQueryParams, defaultFilters);
  const dateFilters = allQueryParams.dateFilter ?
    util.getDateFilterFromQueryParams(allQueryParams) : null;
  return Promise.all([
    dispatch(actions.setFilterItems({ name: 'owners', items: new OrderedSet([user.username]) })),
    ...(Object.keys(filters).length ? [dispatch(actions.setFiltersFromQueryParams(filters))] : []),
    ...(dateFilters ? [dispatch(actions.selectDateFilter(dateFilters))] : []),
  ]);
};
